export default __webpack_public_path__ + "static/media/banner4.abfa4144.jpg";